module.exports = __webpack_public_path__ + "static/img/school-5.b993093.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/school-5.png
// module id = dKhA
// module chunks = 1